import Rest from '@services/Rest';

/**
 * @typedef {SalesService}
 */
export default class SalesService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/sale'

  updateClientEmail(saleId, email) {
    return this.put(`/${saleId}/client/email`, {
      email,
      confirmation: 'ALTERAR E-MAIL',
    })
  }

  refund(saleId, confirmation) {
    return this.post(`/${saleId}/refund`, { confirmation })
  }

  cancelSubscription(clientContractId, confirmation) {
    return this.getHttp()
      .delete(`${this.constructor.base}/sales-next/subscription/${encodeURIComponent(clientContractId)}`, {
        data: { confirmation },
      })
      .then(this.constructor.then)
  }

  getRefundReceipt(saleId) {
    return this.get(`/refund-pdf/${saleId}`).then((response) => {
      const pdf =
        (response && response.data && response.data.pdf) ||
        (response && response.messages && response.messages.pdf)

      if (!pdf) {
        throw new Error('Refund receipt PDF not found in response')
      }

      return pdf
    })
  }
}
